<template>
    <div class="base-my-trumpet" :class="{ 'mytrumpet-sp': $store.state.screen == 1 }">
        <div class="content">
            <div class="header">
                <div class="back-img" @click="$router.back()">
                    <img class="back" src="~images/back.png" />
                </div>
                <div class="title">我的小号</div>
                <div class="ser" @click="isexplain = true">小号说明</div>
            </div>
            <div class="content-auto">
                <div class="tips">用户最多可在游戏中创建10个小号，创建后不可删除</div>
                <div>
                    <div class="list" v-for="(item, index) in list" :key="index" >
                        <div class="name" v-show="item.stu == 0">
                            <!--  @click="toGame(item.app_uid)" -->
                            <div class="nicName">{{ item.nick_name }}</div>
                            <span v-if="index == 0">【当前登录】</span>
                        </div>
                        <input type="text" class="name" :ref="item.ref" autofocus v-model="item.nick_name"
                            @blur="onBlur(index)" v-show="item.stu == 1" />
                        <img src="~images/edit.png" @click="onEdit(index)" />
                    </div>
                </div>
            </div>
        </div>
        <div class="btn" @click="isadd = true" v-if="list.length < 10">增加小号</div>
        <transition name="component-fade" mode="out-in">
            <BaseTrumpetExplain @childExplain='childExplain' v-if="isexplain" />
            <BaseTrumpetAdd @childAdd='childAdd' v-if="isadd" />
            <TheTips :msg='msg' v-if="msg" />
        </transition>
    </div>
</template>

<script>
import BaseTrumpetExplain from '@/views/BaseAccount/BasePopup/BaseTrumpetExplain'
import BaseTrumpetAdd from '@/views/BaseAccount/BasePopup/BaseTrumpetAdd'
import TheTips from '@/components/TheTips'

export default {
    name: 'BaseMyTrumpet',
    components: {
        BaseTrumpetExplain,
        BaseTrumpetAdd,
        TheTips
    },
    data() {
        return {
            msg: null,
            list: [],
            isexplain: false,
            isadd: false,
            accountData: {},
            app_uid: '',
            name: '',
            h5LoginData: {},
            userData:{},
            newToken:''
        }
    },
    methods: {
        onBlur(index) {
            this.list[index].stu = 0
            this.name = this.list[index].nick_name
            if (this.name.replace(/\s*/g, "")) this.modifyName()
        },
        onEdit(index) {
            this.list[index].stu = 1
            this.app_uid = this.list[index].app_uid
            this.$nextTick(() => this.$refs.itemRef[index].focus())
        },
        // 修改小号
        modifyName() {
            let options = {
                uid: this.accountData.uid,
                appid: this.accountData.appid,
                app_uid: this.app_uid,
                nick_name: this.name
            };
            options.sign = this.util.getSign(options, this.accountData.appkey)
            this.$axios.post('https://sdk.gameschain.pro/index.php?g=api&m=userbox&a=modify_app_user_name', this.$qs.stringify(options)).then(res => {
                if (res.data.status == 1) {
                    this.getList()
                }
            }).
                catch(o => {
                    this.msg = '请求失败'
                    setTimeout(() => {
                        this.msg = null
                    }, 2000)
                })
        },
        childExplain(event) {
            this.isexplain = event
        },
        childAdd(event) {
            this.isadd = event
            this.getList()
        },
        // 获取小号列表
        getList() {
            let options = {
                uid: this.accountData.uid,
                appid: this.h5LoginData.appid
            }
            options.sign = this.util.getSign(options, this.h5LoginData.appkey)
            this.$axios.post('https://sdk.gameschain.pro/index.php?g=api&m=userbox&a=app_user_list', this.$qs.stringify(options)).then(res => {
                if (res.data.status == 1) {
                    this.list = res.data.data.list
                    this.list.forEach(item => {
                        this.$set(item, 'stu', 0)
                        this.$set(item, 'ref', 'itemRef')
                    })
                    sessionStorage.setItem('setTrumpet', JSON.stringify(this.list))
                }
            })
        },
        // 重新进入游戏
        toGame(id) {
            console.log("用户中心切换小号--", id, this.config.system)
            let options = {
                uid:this.userData?this.userData.data.uid:this.h5LoginData.uid,
                app_uid: id,
                token:this.newToken,
                appid: this.h5LoginData.appid,
                system: this.config.system ? this.config.system : 1, //系统
                machine_code: this.h5LoginData ? this.h5LoginData.machine_code : 'XXXX', //设备号
            };
            console.log('重新进入游戏111', options);
            options.sign = this.util.getSign(options, this.h5LoginData.appkey);
            options.real_name_verify = 1;   // 是否需要实名验证，1为需要，0为不需要
            this.$axios.post('https://sdk.gameschain.pro/index.php?g=api&m=user&a=check_switch_user', this.$qs.stringify(options)).then(res => {
                if (res.data.status == 1) {
                    console.log('acount成功');
                    this.onLoginSucceed(res.data.data.app_uid, res.data.data.token, res.data.data.uid, res.data)
                    // window.sessionStorage.setItem("userData",JSON.stringify(this.userData))
                } else if (res.data.status == 44) { // 返回44  需要进行实名认证
                    this.$router.push('/base-realname?app_uid=' + id)
                } else {
                    console.log("失败", res.data.msg, res.data)
                    this.msg = res.data.msg
                    setTimeout(() => {
                        this.msg = null
                    }, 2000)
                    this.$message({
                        type:"error",
                        message:res.data.msg
                    })
                }
            }).
                catch(o => {
                    this.msg = '请求失败'
                    setTimeout(() => {
                        this.msg = null
                    }, 2000)
                })
        },
        // 进入游戏成功回调
        onLoginSucceed(account, token, uid, data) {
            let that = this
            if (this.h5LoginData) {
                console.log('进入用户中心前将一些数据保存到accountData');
                // 进入用户中心前将一些数据保存到accountData
                sessionStorage.setItem('accountData', JSON.stringify(data.data))
                this.$router.push('/user')
                // 传给插件accountData
                window.parent.postMessage({ type: "accountData", info: JSON.stringify(data) }, '*')
            }
        },
        // 刷新token
        refreshToken(){
            let options = {
                uid: this.accountData.uid,
                appid: this.h5LoginData.appid,
                token:this.accountData.token? this.accountData.token:this.h5LoginData.token,
            }
            options.sign = this.util.getSign(options, this.h5LoginData.appkey)
            this.$axios.post('https://sdk.gameschain.pro/index.php?g=api&m=user&a=refreshtoken', this.$qs.stringify(options)).then(res => {
                const {data} = res
                console.log("刷新token",res,data,data.status)
                if (data.status == 0) {
                   this.newToken=data.data.token
                        //  this.toGame(id)
                }
            })
        }
    },
    created() {
        this.accountData = JSON.parse(sessionStorage.getItem('accountData'))
        this.h5LoginData = JSON.parse(sessionStorage.getItem("h5LoginData"))
        this.userData = JSON.parse(sessionStorage.getItem('userData'))
        // window.localStorage.setItem("userData",JSON.stringify(this.userData))
        if (sessionStorage.getItem('setTrumpet')) {
            let setTrumpet = JSON.parse(sessionStorage.getItem('setTrumpet'))
            this.list = setTrumpet
        } else {
            this.getList()
        }
        this.refreshToken()
    },
    mounted(){
        this.refreshToken()
    }
}
</script>

<style lang="scss" scoped>
$color: #FF6C22;

// 横屏css
.base-my-trumpet {
    width: 1080px;
    height: 100%;
    background: rgba(0, 0, 0, 0.8);
    padding-bottom: 60px;
    display: flex;
    flex-direction: column;
    transition: all 0.3s;

    .content {
        flex: 1;
        display: flex;
        flex-direction: column;
        overflow-y: scroll;

        .header {
            height: 132px;
            background: rgba($color, 0.8);
            display: flex;
            align-items: center;
            justify-content: center;
            position: relative;

            .back-img {
                width: 192px;
                height: 132px;
                position: absolute;
                left: 0;
                display: flex;
                align-items: center;
                justify-content: center;

                .back {
                    width: 72px;
                    height: 72px;
                }
            }

            .title {
                font-size: 51px;
            }

            .ser {
                height: 132px;
                font-size: 39px;
                position: absolute;
                right: 60px;
                text-align: center;
                display: flex;
                align-items: center;
            }
        }

        .content-auto {
            flex: 1;
            overflow-y: scroll;
            padding: 0 60px;

            .tips {
                font-size: 39px;
                margin: 80px 0 60px;
            }

            .list {
                height: 120px;
                border-radius: 18px;
                background: rgba(255, 255, 255, 0.2);
                padding: 0 45px;
                margin-bottom: 30px;
                display: flex;
                justify-content: space-between;
                align-items: center;
            }

            .list:last-child {
                margin-bottom: 60px;
            }

            .list .name {
                flex: 1;
                height: 120px;
                color: #fff;
                font-size: 39px;
                border: 0;
                background: transparent;
                outline: none;
                display: flex;
                align-items: center;
            }

            .list .name .nicName {
                max-width: 700px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
            }

            .list .name span {
                color: $color;
            }

            .list img {
                width: 60px;
                height: 60px;
                margin-left: 45px;
            }

            .list:first-child .name .nicName {
                max-width: 500px;
            }
        }
    }

    .btn {
        height: 120px;
        font-size: 39px;
        border-radius: 18px;
        background: $color;
        margin: 0 60px;
        display: flex;
        align-items: center;
        justify-content: center;
    }
}

// 竖屏css
.mytrumpet-sp {
    width: 100%;
    padding-bottom: 90px;

    .content {
        .header {
            height: 240px;
            border-radius: 60px 0 0 0;

            .back-img {
                width: 290px;
                height: 240px;

                .back {
                    width: 130px;
                    height: 130px;
                }
            }

            .title {
                font-size: 92px;
            }

            .ser {
                height: 240px;
                font-size: 60px;
                right: 80px;
            }
        }

        .content-auto {
            padding: 0 90px;

            .tips {
                font-size: 60px;
                margin: 120px 0 90px;
            }

            .list {
                height: 200px;
                border-radius: 32px;
                padding: 0 60px;
                margin-bottom: 54px;
            }

            .list:last-child {
                margin-bottom: 90px;
            }

            .list .name {
                height: 200px;
                font-size: 70px;
            }

            .list img {
                width: 100px;
                height: 100px;
                margin-left: 60px;
            }
        }
    }

    .btn {
        height: 200px;
        font-size: 70px;
        border-radius: 32px;
        margin: 0 90px;
    }
}
</style>